export const IMAGE = "https://i2.wp.com/asvs.in/wp-content/uploads/2017/08/dummy.png?fit=399%2C275";


// WEBPACK FOOTER //
// ./src/constants/dummy.js